export const TERMS_OF_USE_TEXT = `TERMOS DE USO DA PLATAFORMA DE GESTAO DE LICENCIAMENTO AMBIENTAL

1. ACEITACAO DOS TERMOS

Ao acessar ou utilizar a plataforma de gestao de licenciamento ambiental ("Plataforma"), o usuario declara ter lido, compreendido e concordado integralmente com os presentes Termos de Uso.

Caso nao concorde com qualquer disposicao, o usuario devera abster-se de utilizar a Plataforma.

2. DEFINICOES

Para os fins destes Termos:

Plataforma: sistema SaaS de gestao de licenciamento ambiental.
Usuario: qualquer pessoa fisica ou juridica que utilize a Plataforma.
Prefeitura: orgao publico municipal contratante da Plataforma.
Operadora: empresa responsavel pelo desenvolvimento e manutencao da Plataforma.
Controladora: a Prefeitura, responsavel pelas decisoes sobre o tratamento de dados pessoais.
Dados Pessoais: qualquer informacao relacionada a pessoa natural identificada ou identificavel.

3. OBJETO

A Plataforma tem como objetivo permitir a gestao digital de processos de licenciamento ambiental, incluindo solicitacao, analise, acompanhamento e emissao de licencas.

4. CADASTRO E RESPONSABILIDADE DO USUARIO

4.1. O usuario se compromete a fornecer informacoes verdadeiras, completas e atualizadas.

4.2. O usuario e responsavel por:
Manter a confidencialidade de suas credenciais de acesso;
Nao compartilhar login e senha com terceiros;
Todas as atividades realizadas em sua conta.

4.3. O usuario devera notificar imediatamente a Prefeitura ou a Plataforma em caso de uso nao autorizado de sua conta.

5. USO ADEQUADO DA PLATAFORMA

O usuario se compromete a utilizar a Plataforma de forma etica e legal, sendo vedado:
Inserir informacoes falsas ou fraudulentas;
Utilizar a Plataforma para fins ilicitos;
Tentar acessar dados de outros usuarios sem autorizacao;
Praticar qualquer ato que comprometa a seguranca da Plataforma.

6. SEGURANCA DA INFORMACAO

6.1. A Plataforma adota medidas tecnicas e organizacionais adequadas para proteger os dados.

6.2. O usuario reconhece que a seguranca tambem depende de suas proprias acoes, especialmente quanto ao uso de credenciais.

6.3. O usuario sera responsavel por danos decorrentes de:
Compartilhamento indevido de acesso;
Uso negligente da conta;
Violacao intencional de seguranca.

7. TRATAMENTO DE DADOS PESSOAIS

7.1. O tratamento de dados pessoais sera realizado em conformidade com a legislacao aplicavel, especialmente a LGPD.

7.2. A Prefeitura atua como Controladora dos dados pessoais, sendo responsavel pelas decisoes sobre o tratamento.

7.3. A Plataforma atua como Operadora, tratando os dados conforme instrucoes da Prefeitura.

7.4. Os dados poderao ser utilizados para:
Execucao de politicas publicas;
Cumprimento de obrigacoes legais;
Processamento de solicitacoes de licenciamento.

7.5. O usuario podera exercer seus direitos junto a Prefeitura, conforme previsto na LGPD.

8. RESPONSABILIDADES DAS PARTES

8.1. Da Prefeitura (Controladora)
Definir a finalidade e base legal do tratamento de dados;
Garantir a conformidade com a legislacao;
Atender solicitacoes dos titulares de dados.

8.2. Da Plataforma (Operadora)
Tratar os dados conforme instrucoes da Prefeitura;
Implementar medidas de seguranca adequadas;
Nao utilizar os dados para fins proprios.

8.3. Do Usuario
Fornecer informacoes corretas;
Utilizar a Plataforma de forma adequada;
Responder por atos realizados com sua conta.

9. LIMITACAO DE RESPONSABILIDADE

9.1. A Plataforma nao se responsabiliza por:
Uso indevido por parte do usuario;
Falhas decorrentes de fatores externos (internet, terceiros, etc.);
Indisponibilidade temporaria do sistema.

9.2. A Plataforma nao sera responsavel por danos causados por:
Informacoes incorretas fornecidas pelo usuario;
Compartilhamento indevido de credenciais.

9.3. Nenhuma disposicao destes Termos exclui responsabilidades legais obrigatorias previstas na legislacao brasileira.

10. PROPRIEDADE INTELECTUAL

Todos os direitos relacionados a Plataforma sao de propriedade da Operadora, sendo vedada a reproducao, modificacao ou distribuicao sem autorizacao.

11. PENALIDADES

O descumprimento destes Termos podera resultar em:
Suspensao temporaria da conta;
Cancelamento do acesso;
Comunicacao as autoridades competentes, quando aplicavel.

12. SUSPENSAO E CANCELAMENTO

A Prefeitura podera suspender ou cancelar o acesso do usuario em caso de violacao destes Termos ou por necessidade administrativa.

13. ALTERACOES DOS TERMOS

Os presentes Termos poderao ser atualizados a qualquer momento. O uso continuo da Plataforma apos alteracoes implica concordancia com os novos termos.

14. LEGISLACAO E FORO

Estes Termos serao regidos pelas leis da Republica Federativa do Brasil.

Fica eleito o foro da comarca da Prefeitura contratante para dirimir eventuais controversias.

15. DISPOSICOES GERAIS

15.1. Estes Termos nao criam qualquer vinculo empregaticio entre as partes.

15.2. Caso qualquer clausula seja considerada invalida, as demais permanecerao em pleno vigor.`;